import React from 'react'
import CreateBadge from '../CreateBadge/CreateBadge'

function Home() {
  return <CreateBadge />
}

export default Home
